import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Inspections_ModuleContextService } from './Inspections.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Inspections_task_date_types_dd_ComponentContextService {
  private readonly moduleContext: Inspections_ModuleContextService;

  constructor(moduleContext: Inspections_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'task_date_types_dd',
      type: ComponentType.selector
    }
  }
}